import classNames from 'clsx';
import React from 'react';

import Button from '@swf/components/StarsButton/StarsButton';
import type { ChestAsset } from '@swf/core/types/ChestInventory';
import { ChestLockedType } from '@swf/core/types/Notification';

import ConfigurableChest from '../ConfigurableChest/ConfigurableChest';
import Padlock from '../assets/padlock.svg';
import styles from '../shared.scss';

import { TXTWCL_Unlock } from './IceLockedChest.messages.json';

interface Props {
  chestText: string;
  chestType: string;
  isAvailable: boolean;
  tierId: number;
  assets: ChestAsset[];
  customSkin?: string;
  logoName?: string;
  lockType?: string;
}

const IceLockedChest: React.FC<Props> = ({
  chestText,
  isAvailable,
  lockType,
  chestType,
  tierId,
  customSkin,
  logoName,
  assets
}) => (
  <div className={classNames(styles.tile, { [styles.inactive]: !isAvailable })}>
    {!isAvailable && lockType === ChestLockedType.IceLocked && (
      <div className={classNames(styles.icon, styles.iconLocked)}>
        <Padlock />
      </div>
    )}
    <span className={styles.chestName}>{chestText}</span>
    <ConfigurableChest
      assets={assets}
      chestType={chestType}
      customSkin={customSkin}
      logoName={logoName}
      tierId={tierId}
    />
    <Button
      variant="secondary"
      size="small"
      className={styles.unlockButton}
      href="/account/ice/challenges"
      translation={TXTWCL_Unlock}
    />
  </div>
);

export default IceLockedChest;
